<template>
    <inertia-link :href="this.$route('dashboard.user.home', { user: user.id })" class="nav_logo">
        <svg class="icon nav_logo_favicon">
            <use xlink:href="#apicenter-logo-favicon"></use>
        </svg>
        <svg class="icon label nav_logo_text">
            <use xlink:href="#apicenter-logo-text"></use>
        </svg>
    </inertia-link>
</template>
<script>
export default {
    name: "SidebarLogo",

    props: {
        user: Object
    }
}
</script>
